<template>
    <div class="page-wrapper">
    <CustomHeader :text="$t('activityName.daily_first_recharge')" :is-popup-close-back-icon="true"
        @close-popup="backNavigate" />
    <div class="bannerContainer">
        <img :src="dataSet.bannerIcon" alt="">
    </div>
    <div class="recharge_content">
        <div class="recharge_container">
            <div class="subContainer">
                <div class="day_num" v-for="(item, index) in dataSet.configList" :key="index" @click="selectTab(item)">
                    <div class="numberText" :style="{
                        backgroundImage: dataSet.selectedTabData?.day === item?.day
                            ? `url(${require('@/assets/themeThree/TabAfterr.png')})`
                            : `url(${require('@/assets/themeThree/TabBefore.png')})`,
                        opacity: dataSet.selectedTabData?.day === item?.day ? 2 : 1
                    }" :class="dataSet.selectedTabData?.day === item?.day ? 'activeNumText' : ''">{{ item?.day }}</div>
                    <div class="selectIcon">
                        <img v-if="dataSet.selectedTabData?.day === item?.day" src="@/assets/themeThree/ArrowTab.png"
                            alt="">
                        <div v-else style="padding-bottom:15px ;"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="detailsCard">
            <van-row class="cardTitle">
                <van-col span="2" class="titleImage">
                    <img src="@/assets/firstRecharge/frch_title_icon.png" alt="">
                </van-col>
                <van-col span="20" style="padding-left:5px;">{{ $t('activity.firstDepositTitle') }}</van-col>
                <van-col span="24" class="textImage">
                    <img v-if="dataSet.selectedTabData?.activeStatus === 1 && dataSet.isRewardEligible"
                        src="@/assets/firstRecharge/frch_sttaus_notstart.png" alt="">
                    <img v-else src="@/assets/firstRecharge/frch_status_unactivated.png" alt="">
                </van-col>
            </van-row>
            <div class="tableContainer">
                <van-row class="tableHead">
                    <van-col span="12" class="tableTitle">{{
                        $t('activity.depositAmount') }}</van-col>
                    <van-col span="12" class="tableTitle">{{ $t('activity.additionalBonus') }}</van-col>
                </van-row>
                <div style="padding: 0 5px;" v-for="(item, i) in dataSet.selectedTabData?.recharge_config" :key="i">
                    <van-row class="tabelRaws" style="border-bottom: 1px solid #998ba18a;">
                        <van-col span="12" class="tableTitle tabelValue1">
                            <div class="rs-icon">R$</div>
                            <span>{{ formatCurrency(item?.credits) }}</span>
                        </van-col>
                        <van-col span="12" class="tableTitle tabelValue2">
                            <div class="rs-icon">R$</div>
                            <span>{{ formatCurrency(item?.credits) }}</span>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom_text" v-if="dataSet.activityInfo?.length > 0">
        <van-row style="padding-bottom: 10px;">
            <van-col span="24" class="title">
                <div class="ruleHeader">
                    <img class="side-icon" src="@/assets/firstRecharge/tittleLine.png" />
                    <div class="title">{{ $t('common.activityTitle') }}</div>
                    <img class="side-icon flipped" src="@/assets/firstRecharge/tittleLine.png" />
                </div>

            </van-col>
        </van-row>
        <div class="line_text" v-for="(item, index) in dataSet.activityInfo" :key="index">
            {{ item }}
        </div>
    </div>

    <div class="footerActionContainer">
        <div class="statusButton" v-if="dataSet.selectedTabData?.record">
            <p v-if="setActivityStatus() == 0" style="color: #0484ff;">{{ $t('activityStatus.pending') }}</p>
            <p v-else-if="setActivityStatus() == 1" style="color: #36d836;">{{ $t('activityStatus.completed') }}</p>
            <p v-else-if="setActivityStatus() == 2" style="color: #ff0000;">{{ $t('activityStatus.noRewards') }}</p>
            <p v-else style="color: #ff0000;">{{ $t('activity.overdue') }}</p>
        </div>
        <div v-else
            :class="dataSet.selectedTabData?.activeStatus === 1 && dataSet.isRewardEligible ? 'depositBtn' : 'deposit-disabled'"
            @click="goToDeposit">
            {{ $t('activity.immediateDeposit') }}
        </div>
    </div>
</div>

</template>
<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import { } from 'vue';
import { FirstDepositData } from '@/view/firstDeposit/newFirstRecharge';
import { useUserStore } from '@/stores/user';
import { useRouter } from 'vue-router';
import { formatCurrency } from '@/utils/commonFunction';
const userStore = useUserStore()
const router = useRouter()
const props = defineProps<{
    dataSet: FirstDepositData
}>()
const emits = defineEmits(['goToDeposit', 'selectTab'])

const goToDeposit = () => {
    emits("goToDeposit")
    localStorage.setItem('showDepositBackIcon', '1')
}

const setActivityStatus = () => {
    return props.dataSet.selectedTabData.record?.status
}

const selectTab = (item: any) => {
    emits("selectTab", item)
}

const backNavigate = () => {
    userStore.setTakeFirstDeposit(false)
    router.replace({ path: '/home', query: {} })
}
</script>
<style scoped>

.page-wrapper {
    background-color: #090f1f;
    min-height: 100vh;
}

.bannerContainer img {
    width: 100%;
}

.bannerContainer {
    padding-top: 50px;
}

.recharge_content {
    padding: 0 25px;
}

.recharge_container {

    background-image: linear-gradient(to bottom, #17236b, #0b0e2d);
    padding: 10px 15px 0;
    border-radius: 15px;

}

.recharge_container::-webkit-scrollbar {
    display: none;
}

.subContainer {
    max-width: 100%;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.day_num {
    position: relative;
    flex: 0 0 auto;
    justify-content: center;
    width: 20%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.day_num img {
    width: 100%;
}

.numberText {
    color: #4092ea;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-repeat: repeat;
    width: 55px;
    height: 55px;
}

.activeNumText {
    color: rgb(21, 64, 132);
}

.selectIcon {
    display: flex;
    justify-content: center;
}

.selectIcon img {
    height: 15px;
    width: 20px;
}

.detailsCard {
    background-color: #0b0e2d;
    border: 2px solid #3247CF;
    border-radius: 15px;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 15px 15px;
    box-shadow: 0px 0px 10px rgba(77, 98, 241, 0.4);
}

.cardTitle {
    display: flex;
    align-items: center;
    color: #25ca88;
    font-size: 18px;
    padding: 10px 0;
}

.titleImage img {
    width: 85%;
}

.textImage img {
    width: 100%;
}

.tableContainer {
    background-color: #0b0e2d;
    padding: 20px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 12px;

}

.tableHead {
    display: flex;
    width: 100%;
    padding: 10px 0;
    margin-bottom: 5px;
    align-items: flex-start;
}

.tableTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    color: #a9d3ff;
    font-size: 14px;
    line-height: 1.4;
    padding: 0 5px;
    word-break: break-word;
    height: auto;
    min-height: 34px;
}

.tabelRaws {
    display: flex;
    align-items: center;
    color: #FFFFFF;
    background: linear-gradient(90deg, #4d66eb 0%, #209199 100%);
    border-radius: 15px;
    padding: 10px 0;
}

.tableTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #a9d3ff;
    font-size: 14px;
    line-height: 1.2;
    padding: 0 5px;
    word-break: break-word;
    min-height: 38px;
    flex: 1;
}

.tabelValue1,
.tabelValue2 {
    padding: 0 !important;
}

.tabelValue1 span {
    font-weight: bold;
    color: #fff;
    font-size: 16px;
    padding: 0 10px;
}

.tabelValue2 span {
    font-weight: bold;
    color: #FFEE00;
    font-size: 16px;
    padding: 0 10px;
}



.depositBtnContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
}

.statusButton {
    color: #cc3300;
    font-weight: 600;
    background: linear-gradient(90deg, #e9ca8662 0%, #d8be837e 50%, #d8a84174 100%);
    border-radius: 10px;
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 30px;
    align-items: center;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.4);
    cursor: pointer;
    position: center;

}

.depositBtn {
    color: #cc3300;
    font-weight: 600;
    background: linear-gradient(90deg, #e9c986 0%, #d8bf83 50%, #d8a841 100%);
    border-radius: 10px;
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 30px;
    align-items: center;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.4);
    cursor: pointer;
    position: center;
    font-size: 18px;
}

.bottom_text {
    padding: 24px;
    max-width: 500px;
    margin: 16px  0 0;
    background-color: transparent;
    padding-bottom: 120px !important;
}

.footerActionContainer {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 95%;
    z-index: 999;
    background: #293856 !important;
    backdrop-filter: blur(10px);
    padding: 12px;
    border-radius: .875rem;
    border: .0625rem solid #394d7a;
    box-shadow: 0 .25rem 1.1rem rgba(21, 23, 138, .25);
    display: flex;
    justify-content: center;
    align-items: center;
}

.statusButton p {
    font-weight: 600;
    margin: 10px 0;
}

.deposit-disabled {
    background: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.2);
    width: 100%;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.title-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 12px;
    padding: 20px 0;
    margin: 0 auto;
}

.title {
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    white-space: nowrap;
    padding: 10px;
}

.line_text {
    color: #7485aa;
    font-size: 18px;
    padding: 10px;
    line-height: 1.5;
}

.rs-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: radial-gradient(circle, #8792ce 10%, #8aaafb 80%);
    border: 1.5px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 8px 2px rgba(130, 170, 255, 0.6),
        inset 0 0 4px rgba(255, 255, 255, 0.9);
    color: #fff;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    flex-shrink: 0;
}


.ruleHeader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 10px;
    position: relative;
    z-index: 10;
}

.side-icon {
    width: 60px;
    height: auto;
    display: block;
}

.flipped {
    transform: scaleX(-1);
}

.title {
    color: #ffffff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    white-space: nowrap;
}


@media(min-width: 450px) {
    .numberText {
        width: 65px;
        height: 65px;
    }
}

@media(min-width: 360px) {
    .statusButton {
        width: 80%;
    }

    .tabelRaws {
        padding: 5px 0px;
    }


}

@media screen and (min-width: 768px) {
    .line_text {
        font-size: 18px;
    }

    .statusButton {
        font-size: 18px !important;
    }

    .depositBtn {
        font-size: 18px !important;
    }


}

@media screen and (max-width: 360px) {
    .line_text {
        font-size: 14px;
        padding: 8px;
    }

    .side-icon {
        width: 30px;
    }

    .title {
        font-size: 16px;
    }

    .footerActionContainer {
        width: 92%;
        height: 35px;
    }

    .statusButton{
        height: 25px;
        font-size: 14px !important;
    }

    .cardTitle {
        font-size: 14px;
    }   

    .depositBtn {
        font-size: 14px !important;
    }
}
</style>